import { getUid } from '@helpers/helpers';
import { automationCategoryFilterType } from './helper';

export const AUTOMATION_OPERATOR_AND = 'and';
export const AUTOMATION_OPERATOR_OR = 'or';

export const categoryToConditionFilterType = (category) => automationCategoryFilterType(category);

// Option values reach the form as the catalog declares them - the application form schema
// hands out strings, other filters hand out ints - so selection is compared by string form.
const isSameOptionValue = (a, b) => String(a) === String(b);

export const isOptionValueSelected = (raw, optionValue) => (
    (raw || []).some((v) => isSameOptionValue(v, optionValue))
);

export const createConditionRow = ({ filter, value = [] }) => ({
    filter,
    value,
    rowKey: getUid(),
});

export const createConditionGroup = ({ op = AUTOMATION_OPERATOR_AND, conditions = [] } = {}) => ({
    groupKey: getUid(),
    op,
    conditions,
});

export const canAddCondition = (group, option) => {
    if (!option) {
        return false;
    }
    if (option.allowed_multiple) {
        return true;
    }
    const conditions = Array.isArray(group?.conditions) ? group.conditions : [];
    return !conditions.some((c) => c.filter === option.id);
};

export const removeConditionFromGroup = (group, index) => {
    const conditions = Array.isArray(group?.conditions) ? group.conditions : [];
    const next = conditions.filter((_, i) => i !== index);
    if (next.length === 0) {
        return null;
    }
    return { ...group, conditions: next };
};

export const toggleValueInList = (raw, optionValue, checked) => {
    const next = (raw || []).filter((v) => !isSameOptionValue(v, optionValue));
    if (checked) {
        next.push(optionValue);
    }
    return next;
};
